import { Component } from '@angular/core';

@Component({
  templateUrl: './stats-preview.html'
})
export class StatsPreviewComponent {}
